module.exports = __webpack_public_path__ + "img/university2.ec128d94.png";